import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { sendAcceptanceEmail } from "store/actions/instituteRequestsAction";
import { rejectRequest } from "store/actions/instituteRequestsAction";
import { acceptRequest } from "store/actions/instituteRequestsAction";
import { getInstituteRequests } from "store/actions/instituteRequestsAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const InstituteRequest = () => {
  let dispatch = useDispatch();
  const { requests, requestsLastDocument, requestsHasMore } = useSelector(
    (state) => state.requestInstitute
  );
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [requestData, setRequestData] = useState("");
  const [localRequests, setLocalRequests] = useState([]);
  const [loader, setLoader] = useState({
    bth: false,
    data: true,
    loadMore: false,
  });
  const infoPoints = [
    "When a fan places a request related to an institute, it appears in the admin panel for review. The admin carefully evaluates the details of the request and has the authority to either accept or reject it based on the platform’s guidelines and relevance of the information provided.",
  ];
  const subPoints = [];
  const infoTitle = "Institute Request Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    setLocalRequests(requests);
  }, [requests]);

  const columns = ["State", "City", "Institute", "Email", "Created At"];
  const keyMap = {
    State: "state",
    City: "city",
    Institute: "institute",
    Email: "email",
    "Created At": "createdAt",
  };

  const formattedData = localRequests.map((item) => ({
    ...item,
    createdAt: item.createdAt
      ? moment.unix(item.createdAt.seconds).format("M/D/YYYY")
      : "N/A",
  }));

  useEffect(() => {
    dispatch(
      getInstituteRequests("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  const loadMoreRequests = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getInstituteRequests(requestsLastDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
    setLoader((prev) => ({
      ...prev,
      btn: false,
      data: false,
    }));
  };

  const handleRequest = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));

    if (actionType === "Accept") {
      dispatch(
        acceptRequest(requestData, () => {
          dispatch(sendAcceptanceEmail(requestData));
          setLocalRequests((prevRequests) =>
            prevRequests.filter((item) => item.id !== requestData.id)
          );
          dispatch(getInstituteRequests("", () => {}));
          toast.success("Request accepted successfully");
          toggleModal();
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
        })
      );
    } else {
      dispatch(
        rejectRequest(requestData, () => {
          setLocalRequests((prevRequests) =>
            prevRequests.filter((item) => item.id !== requestData.id)
          );
          dispatch(getInstituteRequests("", () => {}));
          toast.success("Request rejected successfully");
          toggleModal();
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
        })
      );
    }
  };

  const renderActions = (row) => (
    <>
      <Button
        size="sm"
        color="primary"
        onClick={() => {
          toggleModal();
          setActionType("Accept");
          setRequestData(row);
        }}
      >
        Accept
      </Button>{" "}
      <Button
        size="sm"
        color="danger"
        onClick={() => {
          toggleModal();
          setActionType("Reject");
          setRequestData(row);
        }}
      >
        Reject
      </Button>
    </>
  );

  return (
    <div>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="pb-2">
          {loader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <TableComponent
              columns={columns}
              data={formattedData}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}

          {requests.length > 4 && (
            <div className="text-center py-4">
              <Button
                onClick={loadMoreRequests}
                color="primary"
                disabled={loader.loadMore || !requestsHasMore}
              >
                {" "}
                {loader.loadMore ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={isOpenModal} centered toggle={toggleModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to {actionType} Request.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={handleRequest}>
              {loader.btn ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggleModal}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default InstituteRequest;
